import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  deleteConsultationApi,
  editConsultationTitle,
  feedbackConsultationApi,
  finishConsultationApi,
  getNoneStreamingChatApi,
  switchChitchatApi
} from '@/api/chatApi'
import { CONSULTATION_CHAT_MESSAGE_LIST_DEFAULT_LIMIT, CONSULTATION_LIST_DEFAULT_LIMIT } from '.'
import type { FinishConsultationBody } from '@/api/model/chatType'

/** 상담 종료 (유저가 종료하는 api ) */
export const useFinishConsultation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ consultation_id, body }: { consultation_id: number; body: FinishConsultationBody }) => {
      return finishConsultationApi(consultation_id, body)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['consultationList', CONSULTATION_LIST_DEFAULT_LIMIT] })
      queryClient.invalidateQueries({ queryKey: ['activeConsultation'] })
    }
  })
}

/** 상담 제목 수정 */
export const useEditConsultationTitle = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ consultation_id, title }: { consultation_id: number; title: string }) => {
      return editConsultationTitle(consultation_id, title)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['consultationList', CONSULTATION_LIST_DEFAULT_LIMIT] })
      queryClient.invalidateQueries({
        queryKey: ['consultationChatMessageList', CONSULTATION_CHAT_MESSAGE_LIST_DEFAULT_LIMIT]
      })
    }
  })
}

/** 상담 삭제 */
export const useDeleteConsultation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ consultation_id }: { consultation_id: number }) => {
      return deleteConsultationApi(consultation_id)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['consultationList', CONSULTATION_LIST_DEFAULT_LIMIT] })
    }
  })
}

/** 상담 주제 변경 */
export const useSwitchChitchat = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ consultation_id }: { consultation_id: number }) => {
      return switchChitchatApi(consultation_id)
    },
    onSuccess: (_, { consultation_id }: { consultation_id: number }) => {
      queryClient.invalidateQueries({ queryKey: ['consultationList', CONSULTATION_LIST_DEFAULT_LIMIT] })
      queryClient.invalidateQueries({ queryKey: ['consultationDetail', consultation_id] })
      queryClient.invalidateQueries({ queryKey: ['activeConsultation'] })
    }
  })
}

/* 상담 피드백 */
export const useFeedbackConsultation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ consultation_id, rating, skip }: { consultation_id: number; rating: number; skip: boolean }) => {
      return feedbackConsultationApi(consultation_id, rating, skip)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['consultationList', CONSULTATION_LIST_DEFAULT_LIMIT] })
      queryClient.invalidateQueries({ queryKey: ['activeConsultation'] })
    }
  })
}

/* create none streaming chat  */
export const useStartNewConsultation = () => {
  return useMutation({
    mutationFn: ({ message, block_id }: { message: string; block_id: number }) =>
      getNoneStreamingChatApi(message, block_id),
    retry: false
  })
}
